<template>
    <div class="sup-engine-introduce-comp">
        <div class="re-w1200 re-main-col">
            <div class="top-box">
                <span class="top-title">黑洞引擎</span>
                <span class="top-dis"
                    >一款以B/S、M/S架构为主的三维实时渲染图形引擎，作为数字孪生底座，提供跨平台、多终端支持<br />具备卓越的物理仿真能力，通过云端协同实现高效的端渲染+云渲染灵活切换<br />助力智能建造、智慧工厂、智慧城市等数字孪生业务发展</span
                >
            </div>
            <div class="engine-introduce-img-box">
                <img class="engine-introduce-bg-img" src="@/assets/imgs/home/engine_introduce_bg.png" />
                <div class="engine-introduce-hint-box">
                    <div id="hint-1" class="hint-box hint-box-1">
                        <span class="hint-text-1 hint-text-right">自主可控的核心技术</span>
                        <span class="hint-text-2 hint-text-left"
                            >黑洞引擎拥有高达98.9%的代码自研率，确保了数据安全与平台安全，打破国外技术垄断。</span
                        >
                    </div>
                    <div id="hint-2" class="hint-box hint-box-2">
                        <span class="hint-text-1 hint-text-right">跨平台与多终端支持</span>
                        <span class="hint-text-2 hint-text-left"
                            >支持Windows、Linux及国产操作系统，并提供Web端、Android、iOS、PC的SDK，确保开发者可以在多种设备和环境中高效部署应用。</span
                        >
                    </div>
                    <div id="hint-3" class="hint-box hint-box-3" style="opacity: 1">
                        <span class="hint-text-1 hint-text-left">云端协同的渲染架构</span>
                        <span class="hint-text-2 hint-text-left"
                            >通过云端协同机制，黑洞引擎支持本地端渲染与云端渲染的灵活切换，确保在不同网络环境下的高性能表现，同时降低终端硬件要求，提升用户体验。</span
                        >
                    </div>
                    <div id="hint-4" class="hint-box hint-box-4">
                        <span class="hint-text-1 hint-text-right">卓越的物理仿真渲染</span>
                        <span class="hint-text-2 hint-text-left"
                            >采用先进的渲染算法和技术，提供包括全局光照、PBR材质、阴影系统、动态水面仿真等功能，创建接近真实物理世界的视觉体验。</span
                        >
                    </div>
                    <div id="hint-5" class="hint-box hint-box-5">
                        <span class="hint-text-1 hint-text-left">强大的生态系统</span>
                        <span class="hint-text-2 hint-text-left"
                            >从数据处理到渲染展示，再到二次开发工具，形成完整的解决方案链，助力开发者轻松搭建复杂的应用系统，并推动行业生态协同发展。</span
                        >
                    </div>
                </div>
                <div class="engine-introduce-hover-box">
                    <div class="re-introduce-hover-subbox re-introduce-hover-subbox-1" id="hover-subbox-1">
                        <img id="mask-layer-1" class="mask-layer-img" src="@/assets/imgs/home/introduce/mask_layer.png" />
                        <img class="model-img model-img-special" src="@/assets/imgs/home/introduce/zhihuironghe.png" />
                    </div>
                    <div class="re-introduce-hover-subbox re-introduce-hover-subbox-2" id="hover-subbox-2">
                        <img id="mask-layer-2" class="mask-layer-img" src="@/assets/imgs/home/introduce/mask_layer.png" />
                        <img class="model-img" src="@/assets/imgs/home/introduce/zizhuyanfa.png" />
                    </div>
                    <div class="re-introduce-hover-subbox re-introduce-hover-subbox-3" id="hover-subbox-3">
                        <img id="mask-layer-3" class="mask-layer-img" src="@/assets/imgs/home/introduce/mask_layer.png" style="opacity: 1" />
                        <img class="model-img" src="@/assets/imgs/home/introduce/heidongshishixuanran.png" />
                    </div>
                    <div class="re-introduce-hover-subbox re-introduce-hover-subbox-4" id="hover-subbox-4">
                        <img id="mask-layer-4" class="mask-layer-img" src="@/assets/imgs/home/introduce/mask_layer.png" />
                        <img class="model-img" src="@/assets/imgs/home/introduce/zhihuijiazai.png" />
                    </div>
                    <div class="re-introduce-hover-subbox re-introduce-hover-subbox-5" id="hover-subbox-5">
                        <img id="mask-layer-5" class="mask-layer-img" src="@/assets/imgs/home/introduce/mask_layer.png" />
                        <img class="model-img model-img-special" src="@/assets/imgs/home/introduce/zhihuishuju.png" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const hover_div_list = ref([]);
let hover_auto_timeout = null;
let hover_auto_interval = null;
let hover_curr_index = 0;
const hover_auto_time = 3000;
const hover_start_auto_time = 3000;

onMounted(() => {
    // 获取所有 hover_div_list
    const divs = document.querySelectorAll('.re-introduce-hover-subbox');
    hover_div_list.value = Array.from(divs);
    // 给每个 hoverDiv 添加 mouseover 事件监听器
    hover_addEventListener();
    // 初始时启动自动模式计时器
    hover_auto_timeout = setTimeout(hover_auto_mode, hover_start_auto_time);
});

onUnmounted(() => {
    hover_removeEventListener();
});

// MARK Hover 添加悬浮处理事件
const hover_addEventListener = () => {
    hover_div_list.value.forEach((hoverDiv) => {
        hoverDiv.addEventListener('mouseover', () => hover_handle_style(hoverDiv));
    });
};

// MARK Hover 移除悬浮处理事件
const hover_removeEventListener = () => {
    // 清除所有计时器和事件监听器
    clearTimeout(hover_auto_timeout);
    clearInterval(hover_auto_interval);
    hover_div_list.value.forEach((hoverDiv) => {
        hoverDiv.removeEventListener('mouseover', hover_handle_style);
    });
};

// MARK Hover 悬浮样式
const hover_handle_style = (hoverDiv) => {
    hover_div_list.value.forEach((hoverDiv_temp) => {
        // 隐藏所有
        const hoverBoxId_temp = hoverDiv_temp.getAttribute('id');
        const maskLayerId_temp = 'mask-layer-' + hoverBoxId_temp.slice(-1);
        const maskLayerImg_temp = document.getElementById(maskLayerId_temp);
        maskLayerImg_temp.style.opacity = 0;
        const hintId_temp = 'hint-' + hoverBoxId_temp.slice(-1);
        const hintDiv_temp = document.getElementById(hintId_temp);
        hintDiv_temp.style.opacity = 0;
    });
    // 显示目标
    const hoverBoxId = hoverDiv.getAttribute('id');
    const maskLayerId = 'mask-layer-' + hoverBoxId.slice(-1);
    const maskLayerImg = document.getElementById(maskLayerId);
    maskLayerImg.style.opacity = 1;
    const hintId = 'hint-' + hoverBoxId.slice(-1);
    const hintDiv = document.getElementById(hintId);
    hintDiv.style.opacity = 1;

    // 重置自动模式计时器
    clearTimeout(hover_auto_timeout);
    clearInterval(hover_auto_interval);
    hover_auto_timeout = setTimeout(hover_auto_mode, hover_start_auto_time);
};

// MARK Hover 自动悬浮
const hover_auto_mode = () => {
    hover_auto_interval = setInterval(() => {
        const hoverDiv = hover_div_list.value[hover_curr_index];
        hover_handle_style(hoverDiv);
        hover_curr_index = (hover_curr_index + 1) % hover_div_list.value.length;
    }, hover_auto_time);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-engine-introduce-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .engine-introduce-img-box {
        position: relative;
        margin-top: 40px;
        display: flex;
        width: 100%;
        height: 590px;
        justify-content: center;

        .engine-introduce-hover-box {
            position: absolute;
            top: 0;
            left: 50%;
            width: var(--cont-width-limit);
            height: 100%;
            transform: translate(-50%);

            .re-introduce-hover-subbox {
                position: absolute;
                display: flex;
                cursor: pointer;
            }
            .mask-layer-img {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                opacity: 0;
                transition: var(--animation-opacity-style);
            }
            .model-img {
                position: absolute;
                top: 34px;
                left: 27px;
                right: 27px;
                bottom: 10px;
                width: calc(100% - 54px);
                height: calc(100% - 44px);
            }
            .model-img-special {
                bottom: 15px;
                height: calc(100% - 49px);
            }
            .re-introduce-hover-subbox-1 {
                position: absolute;
                top: 123px;
                left: 188px;
                width: 211px;
                height: 223px;
                display: flex;
            }
            .re-introduce-hover-subbox-2 {
                position: absolute;
                top: -17px;
                left: 398px;
                width: 271px;
                height: 276px;
                display: flex;
            }
            .re-introduce-hover-subbox-3 {
                position: absolute;
                top: 23px;
                left: 813px;
                width: 204px;
                height: 265px;
                display: flex;
            }
            .re-introduce-hover-subbox-4 {
                position: absolute;
                top: 268px;
                left: 333px;
                width: 234px;
                height: 231px;
                display: flex;
            }
            .re-introduce-hover-subbox-5 {
                position: absolute;
                top: 183px;
                left: 646px;
                width: 216px;
                height: 251px;
                display: flex;
            }
        }

        .engine-introduce-hint-box {
            position: absolute;
            top: 0;
            left: 50%;
            width: var(--cont-width-limit);
            height: 100%;
            transform: translate(-50%);

            .hint-box {
                position: absolute;
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                background-color: var(--color-main-light-bg-white);
                width: 340px;
                height: 100px;
                padding: 20px 36px;
                box-sizing: border-box;
                border-radius: 20px;
                box-shadow: var(--color-main-card-shadow-small);
                transition: var(--animation-opacity-style);
                opacity: 0;

                .hint-text-1 {
                    position: relative;
                    width: 100%;
                    font-size: 17px;
                    font-weight: 400;
                    color: var(--color-main-text-primary);
                    line-height: 20px;
                    margin-bottom: 7px;
                }
                .hint-text-2 {
                    position: relative;
                    width: 100%;
                    font-size: 13px;
                    font-weight: 400;
                    color: var(--color-main-text-home-dis);
                    line-height: 18px;
                }
                .hint-text-right {
                    text-align: right;
                }
                .hint-text-left {
                    text-align: left;
                }
            }
            .hint-box-1 {
                height: 100px;
                top: calc(123px + (211px - 85px - 20px));
                left: calc(188px - (333px + 7px));
            }
            .hint-box-2 {
                height: 120px;
                top: 0;
                left: calc(398px - (333px + 7px));
            }
            .hint-box-3 {
                height: 140px;
                top: calc(23px + (265px - 85px - 20px));
                left: calc(813px + 204px + 7px);
            }
            .hint-box-4 {
                height: 120px;
                top: calc(268px + (234px - 85px - 20px));
                left: calc(333px - (333px + 7px));
            }
            .hint-box-5 {
                height: 120px;
                top: calc(183px + (251px - 85px - 20px));
                left: calc(646px + 216px + 7px);
            }
        }

        .engine-introduce-bg-img {
            position: absolute;
            top: 0;
            left: 50%;
            width: var(--cont-width-limit);
            height: 100%;
            transform: translate(-50%);
        }
    }

    .top-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;

        .top-title {
            position: relative;
            height: 60px;
            font-weight: 500;
            font-size: 40px;
            color: var(--color-main-text-primary);
            line-height: 47px;
            display: flex;
            align-items: center;
        }

        .top-dis {
            position: relative;
            margin-top: 32px;
            width: 100%;
            height: 132px;
            font-weight: 400;
            font-size: 24px;
            color: var(--color-main-text-secondary);
            line-height: 44px;
            text-align: center;
            font-style: normal;
        }
    }
}
</style>
